export default class RequestError {
    constructor(code, data) {
        this.code = code
        this.data = data
    }
}